var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.section
    ? _c(
        "div",
        {
          staticClass: "hero",
          class: { first: _vm.first, illustrated: _vm.section.media !== null },
        },
        [
          _c("h1", { staticClass: "title" }, [
            _vm.section.title
              ? _c("strong", {
                  domProps: { innerHTML: _vm._s(_vm.section.title) },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.section.subtitle
              ? _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.section.subtitle) },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("hero-link", {
            attrs: { section: _vm.section },
            on: {
              click: function ($event) {
                return _vm.$emit("scroll")
              },
            },
          }),
          _vm._v(" "),
          _c("transition", { attrs: { name: "grow", appear: "" } }, [
            _vm.section.media
              ? _c("div", { staticClass: "media" }, [
                  _c("img", {
                    attrs: { src: _vm.getUrl(_vm.section.media.id, 1600) },
                  }),
                ])
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }